import { useSettings } from "@utilities/context/settings";
import { COVEO_IGNORE_CLASS } from "@utilities/coveoConst";
import { useDevice } from "@utilities/react/get-device/get-device";
import clsx from "clsx";
import { useEffect, useState } from "react";
import IconCross from "../../public/image/svg/cross.svg";
import styles from "./NotificationBanner.module.scss";

export const NotificationBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  //const [isBannerClosed, setIsBannerClosed] = useState(true);
  const { siteSettings } = useSettings();
  const device = useDevice();
  //const isMobile = device === "mobile";

  /*useEffect(() => {
    const isBannerClosed = getCookie("notificationBannerClosed");
    setIsBannerClosed(!!isBannerClosed);
  }, []);*/
  if (typeof window !== "undefined") {
    useEffect(() => {
      setIsVisible(true);
    }, [window.location?.pathname]);
  }
  const handleClose = () => {
    setIsVisible(false);
    //setCookie({ cookieName: "notificationBannerClosed", value: true });
  };

  /*if (isBannerClosed) {
    return null;
  }*/
  return siteSettings?.turnOnNotificationBanner ||
    siteSettings?.turnOnSiteMaintenanceMode ? (
    <div
      className={clsx(styles["notification-banner"], COVEO_IGNORE_CLASS)}
      style={{ display: isVisible ? "flex" : "none" }}
    >
      <span
        className={styles.close}
        tabIndex={0}
        aria-label="close"
        onClick={handleClose}
      >
        <IconCross />
      </span>
      {siteSettings?.turnOnSiteMaintenanceMode ? (
        <p>{siteSettings?.maintenanceModeBanner}</p>
      ) : null}
      {siteSettings?.turnOnNotificationBanner ? (
        <p>{siteSettings?.notificationBannerMobile}</p>
      ) : null}
    </div>
  ) : null;
};

export default NotificationBanner;
